import { TFunction } from "i18next";
import Card from "../../../components/card/Card";
import { Box, Typography } from "@mui/material";
import {
    ManageButton,
    StyledAccountList,
    StyledAccountListContent,
    StyledAccountSocialBox,
    StyledImage,
    StyledWidgetText,
    ViewAllButton,
    widgetCardContentStyles,
    widgetCardHeaderStyles
} from "../styles";
import { useMemo } from "react";
import { LinkedAccountRepresentation } from "../../../api/representations";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@keycloak/keycloak-ui-shared";

interface LinkedAccountsWidgetProps {
    t: TFunction;
    linkedAccounts: LinkedAccountRepresentation[];
    resourceUrl: string;
    loading: boolean;
}

export default function LinkedAccountsWidget({ t, linkedAccounts, resourceUrl, loading }: LinkedAccountsWidgetProps) {
    const navigate = useNavigate();
    const resolveProviderAlias = (providerAlias: string) => providerAlias === 'epam-microsoft-second' ? 'epam-microsoft' : providerAlias;

    const onManageAccounts = () => {
        navigate("account-security/linked-accounts");
    }

    const accountTitle = `${t('linkedAccounts')} ${linkedAccounts.length ? `| ${linkedAccounts.length}`: ''}`;

    const listAccounts = useMemo(() => {

        if (linkedAccounts.length === 1) {
            const resolvedProviderAlias = resolveProviderAlias(linkedAccounts[0].providerAlias);
            return (
                <Box textAlign="center">
                    <StyledAccountSocialBox width="120px" height="120px">
                        <StyledImage src={`${resourceUrl}/images/socials/${resolvedProviderAlias}.png`} alt={linkedAccounts[0].displayName} />
                    </StyledAccountSocialBox>
                    <Typography>{linkedAccounts[0].displayName}</Typography>
                </Box> 
            );
        }

        return linkedAccounts.slice(0, 3).map((account, index) => {
            const resolvedProviderAlias = resolveProviderAlias(account.providerAlias);

            return (
                <Box key={index} textAlign="center">
                    <StyledAccountSocialBox width="84px" height="84px">
                        <StyledImage {...(resolvedProviderAlias !== 'epam-microsoft' ? { width: '36px' }: { width: '90%' })} src={`${resourceUrl}/images/socials/${resolvedProviderAlias}.png`} alt={account.displayName} />
                    </StyledAccountSocialBox>
                    <Typography>{account.displayName}</Typography>
                </Box>
            );
        });

    }, [linkedAccounts]);

    const action = linkedAccounts.length ? (
        <ViewAllButton component="button" onClick={() => navigate("account-security/linked-accounts")}>{t('viewAll')}</ViewAllButton>) : null;

    return (
        <Card title={accountTitle} action={action} sxContent={widgetCardContentStyles} sxHeader={widgetCardHeaderStyles}>
            { loading ?
                <Spinner /> : 
                (<StyledAccountListContent>
                {!linkedAccounts.length ? (
                    <>
                        <Box>
                            <img src={`${resourceUrl}/images/accounts.svg`} alt="account" />
                        </Box>
                        <StyledWidgetText variant="body1">{t('connectSocialNetworks')}</StyledWidgetText>
                        <ManageButton variant="contained" size="small" onClick={onManageAccounts}>{t('manageAccounts')}</ManageButton>
                    </>
                ) : (
                    <StyledAccountList>
                        {listAccounts}
                    </StyledAccountList>
                )}
            </StyledAccountListContent>)}
        </Card>
    );
}